<template lang="pug">
div(:style="'min-height:' + h")
  .px-0.white.detail-head.head-border
    el-row.pl-5
      el-col(:span="8")
        Breadcrumb(:data="items")
      el-col.pt-5.text-right(:span="15")
        //- el-button(v-show="head.status==2" type="primary" :loading="loading" size="mini" @click="confirm") 签收
        //- el-button(v-show="head.status==2" type="primary" :loading="loading" size="mini" @click="dialogFormVisible=true") 驳回
      el-col.pt-5.text-right(:span="15")
        el-button(
          v-show="type==3 && (head.status==2 || head.status==3)",
          type="primary",
          size="mini",
          :loading="logistics_loading",
          :disabled="parseInt(head.trans_way) === 1",
          @click="getLogistics(head.code)"
        ) 查看物流
        el-button(
          v-show="type==2",
          type="primary",
          size="mini",
          :loading="loading",
          @click="showBillData"
        ) 票据关联
        el-button(
          v-show="type==2",
          type="primary",
          size="mini",
          :loading="loading",
          @click="preserve(1)"
        ) 保存
        el-button(
          v-show="type==2",
          type="primary",
          size="mini",
          :loading="loading",
          @click="preserve(2)"
        ) 保存并发布
        el-button(
          v-show="type==3",
          type="primary",
          size="mini",
          @click="goto('/purchase/purchase_invoice_detail_printing/' + head.id)"
        ) 发票打印
        el-button(
          v-show="(type==3 && head.status==4)||type==2",
          type="primary",
          size="mini",
          @click="del"
        ) 删除
        el-button(
          v-show="type==3 && head.status==2",
          type="primary",
          size="mini",
          @click="cancel_publish"
        ) 取消发布
        el-button(
          v-show="head.status==2&&head.ncShow",
          type="primary",
          size="mini",
          :loading="loading",
          @click="pubNc"
        ) 签收
        //- el-button(
        //-   v-show="head.status==3&&head.ncShow",
        //-   type="primary",
        //-   size="mini",
        //-   @click="retNc"
        //- ) 取消签收
        el-button(type="primary", size="mini", @click="$router.go(-1)") 返回
  div(style="height: 70px")
  el-main.white.pa-3.ma-4
    el-row
      el-col(:span="20")
        div 发票信息
    el-form.mt-4(
      label-width="120px",
      :model="head",
      ref="head",
      :rules="rules",
      size="mini"
    )
      el-row
        el-col(:span="7")
          el-form-item(label="发票单号:")
            span {{ head.code }}
          el-form-item(label="采购组织:")
            span {{ head.org_name }}
          el-form-item(label="物流方式:", prop="trans_way")
            el-radio-group(v-model="head.trans_way", :disabled="disabled")
              el-radio(label="0") 物流
              el-radio(label="1") 其他
          el-form-item(label="预计到票日期:", :prop="disabled ? '' : 'receive_date'")
            el-date-picker.w-100(
              v-model="head.receive_date",
              value-format="yyyy-MM-dd",
              type="date",
              :picker-options="pickerOptions",
              placeholder="预计到票日期",
              :disabled="disabled"
            )
        el-col(:span="7")
          el-form-item(label="采购员:")
            span {{ head.buy_person_name }}
          el-form-item(
            v-if="parseInt(head.trans_way) === 0",
            label="物流公司:",
            prop="trans_org"
          )
            el-select.w-100(
              size="mini",
              v-model="head.trans_org",
              filterable,
              placeholder="物流公司",
              :disabled="disabled"
            )
              el-option(
                v-for="item in wlgs",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              )
          el-form-item(label="开票公司:")
            span {{ head.invoice_org }}
          el-form-item(label="对账合同:")
            span {{ head.code_ct }}
        el-col(:span="7")
          el-form-item(label="联系方式:")
            span {{ head.buy_person_mobile }}
          el-form-item(
            v-if="parseInt(head.trans_way) === 0",
            label="物流单号:",
            prop="trans_code"
          )
            el-input(
              v-model="head.trans_code",
              placeholder="物流单号",
              :disabled="disabled"
            )
          el-form-item(label="发票类型:", prop="type")
            el-select.w-100(
              size="mini",
              v-model="head.type",
              filterable,
              placeholder="发票类型",
              :disabled="disabled"
            )
              el-option(
                v-for="item in fplx",
                :key="item.code",
                :label="item.name",
                :value="item.code"
              )
      el-row
        el-col(:span="21")
          el-form-item(label="备注:")
            el-input(
              v-model="head.remark",
              placeholder="备注",
              :disabled="disabled"
            )
      el-row
        el-col(:span="21")
          el-form-item(label="发票附件:")
            template(v-if="!disabled")
              el-upload(
                :headers="http_header",
                accept=".jpg,.png,.jpeg",
                :file-list="fileList",
                :action="path",
                list-type="picture-card",
                :on-preview="handlePictureCardPreview",
                :on-remove="handleRemove",
                :on-success="handleSuccess",
                :before-upload="beforeUpload"
              )
                i.el-icon-plus
              el-dialog(:visible.sync="dialogVisible")
                img(width="100%", :src="img_url + dialogImageUrl", alt="")
            el-image(
              v-else,
              v-for="(item, i) in fileList",
              :key="i",
              style="width: 150px; height: 150px",
              :src="img_url + item.url",
              fit="contain",
              :preview-src-list="[img_url + item.url]"
            )
    el-alert(
      v-if="type == 2 && head.status == 4",
      :title="'驳回原因:' + head.reject_reason + '。操作时间:' + head.reject_date",
      type="error",
      :closable="false"
    )
    el-row.mt-5.mb-2
      el-col(:span="20")
        div 发票总表
    el-table(:data="[head]", style="width: 100%", size="mini")
      el-table-column(prop="check_account_code", label="对账单号")
      el-table-column(prop="check_account_money", label="对账单金额")
      el-table-column(prop="invoiced_money", label="已开票金额")
      el-table-column(prop="rest_invoice_money", label="可开票金额")
      el-table-column(prop="money", label="本次开票金额", width="180")
        template(slot-scope="scope")
          el-input-number.w-100(
            v-model="scope.row.money",
            size="mini",
            controls-position="right",
            :min="0",
            :precision="2",
            :disabled="true"
          )
    el-row.mt-5
      el-col(:span="20")
        div 入库明细
      el-col(:span="4")
        el-button(
          v-if="type == 2",
          type="primary",
          size="mini",
          @click="dialogTableVisible = true"
        ) 选择入库明细
    el-table(
      :data="body",
      style="width: 100%",
      size="mini",
      show-summary,
      :summary-method="getSummaries2"
    )
      el-table-column(
        prop="receive_date",
        label="收货日期",
        width="120",
        key="receive_date"
      )
      el-table-column(
        prop="customer",
        label="客户",
        width="200",
        key="customer",
        show-overflow-tooltip
      )
      el-table-column(
        prop="stock_type",
        label="存货类别",
        key="stock_type",
        show-overflow-tooltip
      )
      el-table-column(
        prop="stock_name",
        label="存货名称",
        key="stock_name",
        show-overflow-tooltip
      )
      el-table-column(prop="unit", label="单位", width="50", key="unit")
      el-table-column(prop="num", label="数量", width="80", key="num")
      el-table-column(
        prop="tax_price",
        label="含税单价(元)",
        width="100",
        key="tax_price"
      )
      el-table-column(prop="rate", label="税率(%)", width="80", key="rate")
      el-table-column(
        prop="tax_money",
        label="价税合计(元)",
        width="100",
        key="tax_money"
      )
      el-table-column(prop="tax", label="税额", width="100", key="tax")
      el-table-column(
        prop="norigtaxmny",
        label="不含税金额(元)",
        width="100",
        key="norigtaxmny"
      )
      el-table-column(v-if="type != 3", label="操作", width="80", key="op")
        template(slot-scope="scope")
          el-button(
            type="primary",
            plain,
            size="mini",
            @click="del_body(scope.row, scope.$index)"
          ) 删除
    el-row.mt-5
      el-col(:span="20")
        div 关联票据
    el-table(
      :data="bill_item1",
      show-summary,
      :summary-method="getSummaries",
      style="width: 100%",
      size="mini"
    )
      el-table-column(prop="invoice_date", label="开票日期", width="150")
      el-table-column(
        prop="invoice_no",
        label="发票号",
        width="250",
        show-overflow-tooltip
      )
      el-table-column(
        prop="invoice_code",
        label="发票代码",
        width="250",
        show-overflow-tooltip
      )
      el-table-column(prop="money", label="无税金额", width="250")
      el-table-column(prop="tax", label="税额", width="250")
      el-table-column(prop="tax_money", label="价税合计", show-overflow-tooltip)
      el-table-column(label="操作", width="80", key="op")
        template(slot-scope="scope")
          el-button(
            type="primary",
            plain,
            size="mini",
            @click="del_bill(scope.row, scope.$index)"
          ) 删除
  el-dialog(
    title="入库明细",
    :visible.sync="dialogTableVisible",
    width="900px",
    :close-on-click-modal="true",
    :close-on-press-escape="false"
  )
    el-row.mb-3(type="flex", :gutter="20")
      el-col(:span="10")
        el-input(
          v-model="list.key_name",
          placeholder="请输入存货类别",
          clearable,
          size="mini"
        )
      el-col(:span="4")
        el-button(type="primary", @click="search", size="mini") 搜索
    el-table(
      v-loading="loading",
      size="mini",
      ref="multipleTable",
      :data="detail_data",
      row-key="id",
      @selection-change="handleSelectionChange($event)"
    )
      el-table-column(type="selection", width="50")
      el-table-column(prop="stock_no", label="入库单号", width="100")
      el-table-column(prop="receive_date", label="收货日期", width="100")
      el-table-column(
        prop="customer",
        label="客户",
        width="120",
        show-overflow-tooltip
      )
      el-table-column(prop="stock_type", label="存货类别", show-overflow-tooltip)
      el-table-column(prop="stock_name", label="存货名称", show-overflow-tooltip)
      el-table-column(prop="unit", label="单位", width="50")
      el-table-column(prop="num", label="数量", width="70")
      el-table-column(prop="tax_price", label="含税单价(元)", width="90")
      el-table-column(prop="rate", label="税率(%)", width="70")
      el-table-column(prop="tax_money", label="价税合计(元)", width="90")
      el-table-column(prop="order_no", label="订单号", width="100")
      el-table-column(prop="order_price", label="订单单价", width="100")
      el-table-column(prop="order_rate", label="订单税率(%)", width="100")
    el-pagination.mt-3.text-center(
      @size-change="handleSizeChange",
      @current-change="handleCurrentChange",
      :current-page="list.page_num",
      :page-sizes="page_sizes",
      :page-size="list.page_size",
      layout="total,sizes, prev, pager, next, jumper",
      :total="count",
      background
    )
    .dialog-footer(slot="footer")
      el-button(@click="dialogTableVisible = false", size="mini") 取 消
      el-button(type="primary", @click="setBody", size="mini") 确 定
  el-dialog(
    title="票据选择",
    :visible.sync="dialogTableBillVisible",
    width="800px",
    :close-on-click-modal="true",
    :close-on-press-escape="false"
  )
    el-row.mb-3(type="flex", justify="center", :gutter="20")
      el-col(:span="8")
        el-date-picker.w-100(
          v-model="time",
          size="mini",
          type="daterange",
          align="right",
          unlink-panels,
          range-separator="至",
          start-placeholder="开始日期",
          end-placeholder="结束日期",
          value-format="yyyy-MM-dd",
          :picker-options="pickerOptions1"
        )
      el-col(:span="8")
        el-input(
          v-model="bill_list.key_name",
          placeholder="请输入发票号",
          clearable,
          size="mini"
        )
      el-col(:span="4")
        el-button(type="primary", @click="search1", size="mini") 搜索
    el-table(
      v-loading="loading",
      size="mini",
      ref="singleTable",
      :data="billData",
      max-height="300",
      row-key="id",
      @selection-change="handleSelectionChange1($event)"
    )
      el-table-column(type="selection", :selectable="checkStatus", width="50")
      el-table-column(prop="invoice_date", label="开票日期", width="150")
      el-table-column(
        prop="invoice_no",
        label="发票号",
        width="200",
        show-overflow-tooltip
      )
      el-table-column(
        prop="invoice_code",
        label="发票代码",
        width="100",
        show-overflow-tooltip
      )
      el-table-column(prop="money", label="无税金额", width="100")
      el-table-column(prop="tax", label="税额", width="100")
      el-table-column(prop="tax_money", label="价税合计", width="100")
    el-pagination.my-4.text-center(
      @size-change="handleSizeChange1",
      @current-change="handleCurrentChange1",
      :current-page="bill_list.page_num",
      :page-sizes="page_sizes",
      :page-size="bill_list.page_size",
      layout="total,sizes, prev, pager, next, jumper",
      :total="billCount",
      background
    )
    .dialog-footer(slot="footer")
      el-button(@click="dialogTableBillVisible = false", size="mini") 取 消
      el-button(type="primary", @click="setBillDetail", size="mini") 确 定
  el-dialog.dialog(
    title="物流信息",
    :visible.sync="dialogTimeline",
    width="600px",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false"
  )
    div 物流公司: {{ logistics.expName }}
    div 订单历时: {{ logistics.takeTime }}
    el-timeline.mt-4
      el-timeline-item(
        v-if="logistics.list",
        v-for="(item, index) in logistics.list",
        :key="index",
        :timestamp="item.time"
      ) {{ item.status }}
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      h: "",
      data: {},
      head: {},
      body: [],
      invoiceBillDetail: [],
      attachment: [],
      loading: false,
      items: [
        {
          path: "/purchase/purchase_order",
          meta: {
            title: "采购发票",
          },
        },
        {
          path: this.$route.path,
          meta: {
            title: "详情",
          },
        },
      ],
      rules: {
        reason: [
          { required: true, message: "请填写驳回原因", trigger: "blur" },
        ],
        trans_way: [
          { required: true, message: "请选择物流方式", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        receive_date: [
          { required: true, message: "请选择预计到票日期", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (value < this.$utils.getTimeByYMD(new Date())) {
                callback("预计到票时间不能小于当前时间");
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        trans_org: [
          { required: true, message: "请选择物流公司", trigger: "change" },
        ],
        invoice_code: [
          { required: true, message: "请填写发票代码", trigger: "blur" },
        ],
        invoice_no: [
          { required: true, message: "请填写发票号", trigger: "blur" },
        ],
        trans_code: [
          { required: true, message: "请填写物流单号", trigger: "blur" },
        ],
        money: [{ required: true, message: "请填写无税金额", trigger: "blur" }],
        tax_money: [
          { required: true, message: "请填写价税合计", trigger: "blur" },
        ],
        invoice_date: [
          { required: true, message: "请选择开票日期", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (value > this.$utils.getTimeByYMD(new Date())) {
                callback("开票日期不能大于当前时间");
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      fplx: [],
      wlgs: [],
      path: this.$api.file.upload_pic,
      dialogImageUrl: null,
      fileList: [],
      list: {
        key_name: null,
        page_num: 1,
        page_size: 10,
        invoice_id: null,
      },
      count: 0,
      detail_data: [],
      dialogTableVisible: false,
      billData: [],
      billCount: 0,
      dialogTableBillVisible: false,
      img_url: this.$api.file.img_url,
      bill_list: {
        key_name: null,
        begin_date: null,
        end_date: null,
        page_num: 1,
        page_size: 100,
      },
      time: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      bill_item1: [], //关联票据数据
      dialogFormVisible: false,
      form: {
        reason: "",
      },
      pubNcShow: false,
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    type: {
      type: [Number, String],
      default: 1,
    },
  },
  methods: {
    del_bill(e, index) {
      this.bill_item1.splice(index, 1);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          (!values.every((value) => isNaN(value)) && index == 4) ||
          index == 5
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.$utils.toDecimal2OrMore(sums[index]);
        }
      });

      return sums;
    },

    getSummaries2(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value)) && index != 7) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (index == 5) {
            sums[index] = this.$utils.toDecimal3OrMore(sums[index])+'';
          }else{
            sums[index] = this.$utils.toDecimal2OrMore(sums[index]);
          }
        }
      });
      return sums;
    },
    setBillDetail() {
      this.multipleSelection1.forEach((e) => {
        let flag = true;
        for (var i in this.bill_item1) {
          if (e.invoice_no == this.bill_item1[i].invoice_no) flag = false;
        }
        if (flag) this.bill_item1.push(e);
      });
      this.dialogTableBillVisible = false;
    },
    showBillData() {
      this.dialogTableBillVisible = true;
      this.$nextTick(() => {
        this.$refs.singleTable.clearSelection();
        this.bill_item1.forEach((e) => {
          this.billData.forEach((i) => {
            if (e.invoice_no == i.invoice_no) {
              this.$refs.singleTable.toggleRowSelection(i, true);
            }
          });
        });
      });
    },
    search1() {
      this.bill_list.page_num = 1;
      if (this.time) {
        this.bill_list.begin_date = this.time[0];
        this.bill_list.end_date = this.time[1];
      } else {
        this.bill_list.begin_date = null;
        this.bill_list.end_date = null;
      }
      this.getBillList();
    },
    handleSelectionChange1(val) {
      this.multipleSelection1 = val;
    },
    handleSizeChange1(e) {
      this.bill_list.page_size = e;
      this.getBillList();
    },
    handleCurrentChange1(e) {
      this.bill_list.page_num = e;
      this.getBillList();
    },
    // eslint-disable-next-line no-unused-vars
    checkStatus(row, rowIndex) {
      let flag = true;
      this.bill_item1.forEach((e) => {
        if (e.invoice_no == row.invoice_no) {
          flag = false;
        }
      });
      return flag;
    },

    async getBillList() {
      this.loading = true;
      let res = await this.$api.receipt.invoiceBillList(
        this.id,
        this.bill_list
      );
      this.loading = false;
      if (res) {
        this.billData = res.data;
        this.billCount = res.count;
      }
    },
    setBody() {
      if (this.multipleSelection.length == 0) {
        return false;
      }
      if (this.body.length > 0) {
        for (var i in this.multipleSelection) {
          let flag = true;
          for (var j in this.body) {
            if (
              this.body[j].check_account_bid == this.multipleSelection[i].id
            ) {
              flag = false;
              break;
            }
          }
          if (flag) {
            let data = this.$utils.cloneDeep(this.multipleSelection[i]);
            data.check_account_bid = data.id;
            delete data.id;
            this.body.push(data);
          }
        }
      } else {
        let data = this.$utils.cloneDeep(this.multipleSelection[i]);
        data.check_account_bid = data.id;
        delete data.id;
        this.body = data;
      }
      this.$refs.multipleTable.clearSelection();
      this.head.money = 0;
      this.body.forEach((e) => {
        this.head.money += parseFloat(e.tax_money);
      });
      this.dialogTableVisible = false;
    },
    del_body(e, index) {
      if (this.body.length > 1) {
        this.head.money = 0;
        this.body.splice(index, 1);
        for (var i in this.body) {
          if (parseFloat(this.body[i].tax_money))
            this.head.money += parseFloat(this.body[i].tax_money);
        }
      } else {
        this.$notify({
          message: "只剩一条无法删除",
          type: "error",
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      this.list.page_num = 1;
      this.detailList();
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.detailList();
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.detailList();
    },
    async detailList() {
      this.loading = true;
      let res = await this.$api.receipt.detail_list(this.list);
      this.loading = false;
      if (res) {
        this.detail_data = res.data;
        this.count = res.count;
      }
    },
    // eslint-disable-next-line no-unused-vars
    beforeUpload(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/png"
      ) {
        this.$notify({
          message: "上传图片只能是jpg/png/jpeg格式!",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // eslint-disable-next-line no-unused-vars
    handleSuccess(res, file) {
      if (res.code == 200) {
        this.fileList.push({ name: res.data, url: res.data });
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // eslint-disable-next-line no-unused-vars
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    async cancel_publish() {
      this.loading = true;
      let res = await this.$api.receipt.cancel_publish(this.id);
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      }
    },
    async pubNc() {
      this.loading = true;
      let res = await this.$api.receipt.pubNc(this.id);
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      }
    },
    async retNc() {
      this.loading = true;
      let res = await this.$api.receipt.retNc(this.id);
      this.loading = false;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      }
    },
    async preserve(type) {
      this.$refs["head"].validate(async (valid) => {
        if (valid) {
          /*if (this.fileList.length == 0) {
            this.$notify({
              message: "至少需要上传一张发票附件",
              type: "error",
            });
            return false;
          }*/
          this.attachment = [];
          for (var i in this.fileList) {
            this.attachment.push({
              id: this.fileList[i].id,
              img: this.fileList[i].url,
            });
          }
          this.head.money = this.$utils.toDecimal2OrMore(this.head.money);
          this.data.attachment_list = this.attachment;
          this.data.head = this.$utils.cloneDeep(this.head);
          this.data.body_list = this.body;
          this.data.invoiceBillDetail = this.bill_item1;
          if (!this.body.length) {
            this.$notify({
              message: "入库明细不能为空",
              type: "error",
            });
            return false;
          }
          if (!this.data.invoiceBillDetail.length) {
            this.$notify({
              message: "关联票据不能为空",
              type: "error",
            });
            return false;
          }
          if (type == 1) {
            this.data.is_publish = 0;
          } else {
            this.data.is_publish = 1;
          }
          this.loading = true;
          this.data.head.money = this.data.head.money.toString();
          let res = await this.$api.receipt.edit(this.data);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        }
      });
    },
    del() {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let res = await this.$api.receipt.del(this.id);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        })
        .catch(() => {});
    },
    async confirm() {
      this.loading = true;
      let res = await this.$api.receipt.confirm(this.id);
      this.loading = true;
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      }
    },
    async getById() {
      let res = await this.$api.receipt.getById(this.id);
      if (res) {
        this.data = res.data;
        this.head = res.data.head;
        this.body = res.data.body_list;
        this.attachment = res.data.attachment_list;
        this.invoiceBillDetail = res.data.invoiceBillDetail;
        this.invoiceBillDetail.forEach((e) => {
          this.bill_item1.push(e);
        });
        if (this.head.check_account_money != null) {
          this.head.check_account_money = parseFloat(
            this.head.check_account_money
          ).toFixed(2);
        } else {
          this.head.check_account_money = 0;
        }
        if (this.head.invoiced_money != null) {
          this.head.invoiced_money = parseFloat(
            this.head.invoiced_money
          ).toFixed(2);
        } else {
          this.head.invoiced_money = 0;
        }
        if (this.head.rest_invoice_money != null) {
          this.head.rest_invoice_money = parseFloat(
            this.head.rest_invoice_money
          ).toFixed(2);
        } else {
          this.head.rest_invoice_money = 0;
        }
        if (this.head.money != null) {
          this.head.money = parseFloat(this.head.money).toFixed(2);
        } else {
          this.head.money = 0;
        }
        for (var i in res.data.attachment_list) {
          this.fileList.push({
            name: i,
            url: res.data.attachment_list[i].img,
            id: res.data.attachment_list[i].id,
          });
        }
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
    this.list.invoice_id = this.id;
    if (this.type != 3) {
      this.items[1].meta.title = "发布";
    }
    if (this.type == 3) {
      this.disabled = true;
      this.items[1].meta.title = "详情";
    }
    this.getById();
    this.$utils.sleep(500);
    this.detailList();
    this.getBillList();
    this.getDefdoc(this, { code: "fplx" });
    this.getDefdoc(this, { code: "wlgs" });
    // this.pubNcShow = this.$store.state.user.role_name.indexOf("采购") != -1;
  },
};
</script>
